import { ReactNode } from "react";

import "./tooltip.scss";

interface Props {
	tooltip: JSX.Element | string;
	children: ReactNode;
	disable?: boolean;
}

export const Tooltip = ({ tooltip, children, disable }: Props): JSX.Element => {

	if (disable) return <>{children}</>;
	return (
		<div className="smart-tooltip top-center">
			{/* {typeof image === "function" ? (
				image()
			) : (
				<img
					src={image as string}
					alt="tooltip"
					height="18px"
					width="auto"
				/>
			)} */}
			{children}
			<span className="smart-tooltip-content">
				<span className="smart-tooltip-text">{tooltip}</span>
			</span>
		</div>
	);
};
